import {msg} from '@lit/localize';
import BioRedKulturMixed from './baseProfiles/BioRed_Kultur_Mixed.json';
import BioRedKulturMixedZentraleSteuerung from './baseProfiles/BioRed_Kultur_Mixed_ZentraleSteuerung.json';
import BioRedNature from './baseProfiles/BioRed_Nature.json';
import BioRedNatureZentraleSteuerung from './baseProfiles/BioRed_Nature_ZentraleSteuerung.json';

import BioWhiteCulture from './baseProfiles/BioWhite_Kultur.json';
import BioWhiteCulturePowerOff from './baseProfiles/BioWhite_Kultur_Zentralsteuerung.json';
import BioWhiteMixed from './baseProfiles/BioWhite_Mixed.json';
import BioWhiteMixedPowerOff from './baseProfiles/BioWhite_Mixed_Zentralsteuerung.json';
import BioWhiteNature from './baseProfiles/BioWhite_Nature.json';
import BioWhiteNaturePowerOff from './baseProfiles/BioWhite_Nature_Zentralsteuerung.json';

import DynIntCulture from './baseProfiles/DynInt_Kultur.json';
import DynIntCulturePowerOff from './baseProfiles/DynInt_Kultur_Zentralsteuerung.json';
import DynIntMixed from './baseProfiles/DynInt_Mixed.json';
import DynIntMixedPowerOff from './baseProfiles/DynInt_Mixed_Zentralsteuerung.json';
import DynIntNature from './baseProfiles/DynInt_Nature.json';
import DynIntNaturePowerOff from './baseProfiles/DynInt_Nature_Zentralsteuerung.json';

import DynAmbCulture from './baseProfiles/DynAmb_Kultur.json';
import DynAmbCulturePowerOff from './baseProfiles/DynAmb_Kultur_Zentralsteuerung.json';
import DynAmbMixed from './baseProfiles/DynAmb_Mixed.json';
import DynAmbMixedPowerOff from './baseProfiles/DynAmb_Mixed_Zentralsteuerung.json';
import DynAmbNature from './baseProfiles/DynAmb_Nature.json';
import DynAmbNaturePowerOff from './baseProfiles/DynAmb_Nature_Zentralsteuerung.json';

import DynHorCulture from './baseProfiles/DynHor_Kultur.json';
import DynHorCulturePowerOff from './baseProfiles/DynHor_Kultur_Zentralsteuerung.json';
import DynHorMixed from './baseProfiles/DynHor_Mixed.json';
import DynHorMixedPowerOff from './baseProfiles/DynHor_Mixed_Zentralsteuerung.json';
import DynHorNature from './baseProfiles/DynHor_Nature.json';
import DynHorNaturePowerOff from './baseProfiles/DynHor_Nature_Zentralsteuerung.json';


export const lightProfiles = [
	{
		id: 'BioRedCultureMixed',
		label: 'BioRed Culture',
		info: 'BioRed Culture',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xAD2210,
				ctt: 'red'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioRedKulturMixed
		}
	},
	{
		id: 'BioRedCultureMixedPowerOff',
		label: 'BioRed Culture Power Off',
		info: 'BioRed Culture  Power Off',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xAD2210,
				ctt: 'red'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioRedKulturMixedZentraleSteuerung
		}
	},

	{
		id: 'BioRedNature',
		label: 'BioRed Nature',
		info: 'BioRed Nature',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xB12E1B,
				ctt: 'red'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioRedNature
		}
	},
	{
		id: 'BioRedNaturePowerOff',
		label: 'BioRed Nature Power Off',
		info: 'BioRed Nature  Power Off',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xB12E1B,
				ctt: 'red'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioRedNatureZentraleSteuerung
		}
	},


	{
		id: 'BioWhiteCulture',
		label: 'BiologicalWhite Culture',
		info: 'BiologicalWhite Culture',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteCulture
		}
	},
	{
		id: 'BioWhiteCulturePowerOff',
		label: 'BiologicalWhite Culture PowerOff',
		info: 'BiologicalWhite Culture PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteCulturePowerOff
		}
	},

	{
		id: 'BioWhiteMixed',
		label: 'BiologicalWhite Mixed',
		info: 'BiologicalWhite Mixed',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteMixed
		}
	},
	{
		id: 'BioWhiteMixedPowerOff',
		label: 'BiologicalWhite Mixed PowerOff',
		info: 'BiologicalWhite Mixed PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteMixedPowerOff
		}
	},

	{
		id: 'BioWhiteNatur',
		label: 'BiologicalWhite Nature',
		info: 'BiologicalWhite Nature',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteNature
		}
	},
	{
		id: 'BioWhiteNaturPowerOff',
		label: 'BiologicalWhite Nature PowerOff',
		info: 'BiologicalWhite Nature PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0, 1]
			}
		],
		parameterChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'variable',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: BioWhiteNaturePowerOff
		}
	},


	{
		id: 'DynamicIntensityCulture',
		label: 'DynamicIntensity Culture',
		info: 'DynamicIntensity Culture',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntCulture
		}
	},
	{
		id: 'DynamicIntensityCulturePowerOff',
		label: 'DynamicIntensity Culture PowerOff',
		info: 'DynamicIntensity Culture PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntCulturePowerOff
		}
	},

	{
		id: 'DynamicIntensityMixed',
		label: 'DynamicIntensity Mixed',
		info: 'DynamicIntensity Mixed',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntMixed
		}
	},
	{
		id: 'DynamicIntensityMixedPowerOff',
		label: 'DynamicIntensity Mixed PowerOff',
		info: 'DynamicIntensity Mixed PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntMixedPowerOff
		}
	},

	{
		id: 'DynamicIntensityNature',
		label: 'DynamicIntensity Nature',
		info: 'DynamicIntensity Nature',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntNature
		}
	},
	{
		id: 'DynamicIntensityNaturePowerOff',
		label: 'DynamicIntensity Nature PowerOff',
		info: 'DynamicIntensity Nature PowerOff',
		type: 'single',
		renderChannels: [
			{
				id: 'channel0',
				label: 'variable',
				layers: [0]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynIntNaturePowerOff
		}
	},


	{
		id: 'DynamicAmbienceCulture',
		label: 'DynamicAmbience Culture',
		info: 'DynamicAmbience Culture',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Horizontal'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Vertical'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbCulture
		}
	},
	{
		id: 'DynamicAmbienceCulturePowerOff',
		label: 'DynamicAmbience Culture PowerOff',
		info: 'DynamicAmbience Culture PowerOff',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Horizontal'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Vertical'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbCulturePowerOff
		}
	},

	{
		id: 'DynamicAmbienceMixed',
		label: 'DynamicAmbience Mixed',
		info: 'DynamicAmbience Mixed',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: 'Horizontal',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'Vertikal',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbMixed
		}
	},
	{
		id: 'DynamicAmbienceMixedPowerOff',
		label: 'DynamicAmbience Mixed PowerOff',
		info: 'DynamicAmbience Mixed PowerOff',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: 'Horizontal',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'Vertikal',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbMixedPowerOff
		}
	},

	{
		id: 'DynamicAmbienceNature',
		label: 'DynamicAmbience Nature',
		info: 'DynamicAmbience Nature',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: 'Horizontal',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'Vertikal',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbNature
		}
	},
	{
		id: 'DynamicAmbienceNaturePowerOff',
		label: 'DynamicAmbience Nature PowerOff',
		info: 'DynamicAmbience Nature PowerOff',
		type: 'dualOrthogonal',
		renderChannels: [
			{
				id: 'channel0',
				label: 'Horizontal',
				layers: [0]
			},
			{
				id: 'channel1',
				label: 'Vertikal',
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
			{
				dimming: 1,
				color: 0xFFB16E,
				ctt: '3000K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynAmbNaturePowerOff
		}
	},


	{
		id: 'DynamicHorizontalCulture',
		label: 'DynamicHorizontal Culture',
		info: 'DynamicHorizontal Culture',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorCulture
		}
	},
	{
		id: 'DynamicHorizontalCulturePowerOff',
		label: 'DynamicHorizontal Culture PowerOff',
		info: 'DynamicHorizontal Culture PowerOff',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorCulturePowerOff
		}
	},

	{
		id: 'DynamicHorizontalMixed',
		label: 'DynamicHorizontal Mixed',
		info: 'DynamicHorizontal Mixed',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorMixed
		}
	},
	{
		id: 'DynamicHorizontalMixedPowerOff',
		label: 'DynamicHorizontal Mixed PowerOff',
		info: 'DynamicHorizontal Mixed PowerOff',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorMixedPowerOff
		}
	},

	{
		id: 'DynamicHorizontalNature',
		label: 'DynamicHorizontal Nature',
		info: 'DynamicHorizontal Nature',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorNature
		}
	},
	{
		id: 'DynamicHorizontalNaturePowerOff',
		label: 'DynamicHorizontal Nature PowerOff',
		info: 'DynamicHorizontal Nature PowerOff',
		type: 'dualFlat',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Wide'),
				layers: [0]
			},
			{
				id: 'channel1',
				label: msg('Narrow'),
				layers: [1]
			}
		],
		layers: [
			{
				dimming: 1,
				color: 0xFF9227,
				ctt: '2200K'
			},
			{
				dimming: 1,
				color: 0xFFA757,
				ctt: '2700K'
			},
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00', // Berlin
			// localtimezone: 'EST5EDT,M3.2.0/2:00:00,M11.1.0/2:00:00', // New York
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: DynHorNaturePowerOff
		}
	},

	{
		id: 'sun',
		label: 'Test Nacht',
		info: 'Licht zwischen Sonnenaufgang und Sonnenuntergang, hell um Mitternacht',
		renderChannels: [
			{
				id: 'channel0',
				label: msg('Variable'),
				layers: [0]
			}
		],
		layers: [
			{
				brightness: 1,
				color: 0xff4f00,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T12:00:00Z',
			simulation_end: '2025-01-01T12:00:00Z',
			setup: [
				{
					type: 'TARGET',
					space: 'BRIGHTNESS',
					behaviors: [
						{
							type: 'DAILYSCHEDULER',
							entries: [
								{
									type: 'RELATIVETOSUNRISE',
									comment: 'Turns lights of at sunrise',
									hours: 0,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0,
										fade: 0
									}
								},
								{
									type: 'RELATIVETOSUNSET',
									comment: 'turn off at sunset',
									hours: 0,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.5,
										fade: 0
									}
								}
							]
						}
					],
					destinations: [
						{
							type: 'DALI',
							conversions: [],
							assignments: [
								{
									type: 'DAPC',
									offset: 0,
									address: 0
								}
							]
						}
					]
				}
			]
		}
	},
	{
		id: 'fix',
		label: 'Test Stündlich',
		info: 'Stündliche Änderung ohne Fade',
		renderChannels: [
			{
				id: 'channel0',
				label: 'Variable',
				layers: [0]
			}
		],
		layers: [
			{
				brightness: 1,
				color: 0xff4f00,
				ctt: '2700K'
			}
		],
		configuration: {
			format: 1,
			latitude: 52.52,
			longitude: 13.40,
			localtimezone: 'CEST-1CET,M3.2.0/2:00:00,M11.1.0/2:00:00',
			simulation_start: '2024-01-01T11:00:00Z',
			simulation_end: '2024-01-01T12:00:00Z',
			setup: [
				{
					type: 'TARGET',
					space: 'BRIGHTNESS',
					behaviors: [
						{
							type: 'DAILYSCHEDULER',
							entries: [
								{
									type: 'LOCALTIME',
									hours: 0,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 1,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.05,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 2,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.1,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 3,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.15,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 4,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.2,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 5,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.25,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 6,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.3,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 7,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.35,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 8,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.4,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 9,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.45,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 10,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.5,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 11,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.7,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 12,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 1,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 13,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.7,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 14,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.5,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 15,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.45,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 16,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.4,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 17,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.35,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 18,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.3,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 19,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.25,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 20,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.2,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 21,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.15,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 22,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.1,
										fade: 0
									}
								},
								{
									type: 'LOCALTIME',
									hours: 23,
									minutes: 0,
									seconds: 0,
									point: {
										space: 'BRIGHTNESS',
										brightness: 0.05,
										fade: 0
									}
								},
							]
						}
					],
					destinations: [
						{
							type: 'DALI',
							conversions: [],
							assignments: [
								{
									type: 'DAPC',
									offset: 0,
									address: 0
								}
							]
						}
					]
				}
			]
		}
	},
];

export const lightProfileMap = {
	BiologicalWhite: {
		Culture: {
			off: 'BioWhiteCulture',
			on: 'BioWhiteCulturePowerOff',
		},
		Mix: {
			off: 'BioWhiteMixed',
			on: 'BioWhiteMixedPowerOff',
		},
		Nature: {
			off: 'BioWhiteNatur',
			on: 'BioWhiteNaturPowerOff',
		},
	},
	BiologicalRed: {
		Culture: {
			off: 'BioRedCultureMixed',
			on: 'BioRedCultureMixedPowerOff',
		},
		Mix: {
			off: 'BioRedCultureMixed',
			on: 'BioRedCultureMixedPowerOff',
		},
		Nature: {
			off: 'BioRedNature',
			on: 'BioRedNaturePowerOff',
		},
	},
	AdjustingWhite: {
		Culture: {
			off: 'DynamicIntensityCulture',
			on: 'DynamicIntensityCulturePowerOff',
		},
		Mix: {
			off: 'DynamicIntensityMixed',
			on: 'DynamicIntensityMixedPowerOff',
		},
		Nature: {
			off: 'DynamicIntensityNature',
			on: 'DynamicIntensityNaturePowerOff',
		},
	},
	DynamicAmbience: {
		Culture: {
			off: 'DynamicAmbienceCulture',
			on: 'DynamicAmbienceCulturePowerOff',
		},
		Mix: {
			off: 'DynamicAmbienceMixed',
			on: 'DynamicAmbienceMixedPowerOff',
		},
		Nature: {
			off: 'DynamicAmbienceNature',
			on: 'DynamicAmbienceNaturePowerOff',
		},
	},
	DynamicPath: {
		Culture: {
			off: 'DynamicHorizontalCulture',
			on: 'DynamicHorizontalCulturePowerOff',
		},
		Mix: {
			off: 'DynamicHorizontalMixed',
			on: 'DynamicHorizontalMixedPowerOff',
		},
		Nature: {
			off: 'DynamicHorizontalNature',
			on: 'DynamicHorizontalNaturePowerOff',
		},
	},

};
export const lightProfileToFeatureValueMap = {
	BiologicalWhite: 'BiologicalWhite',
	BiologicalRed: 'BiologicalRed',
	AdjustingWhite: 'AdjustingWhite',
	DynamicAmbience: 'DynamicAmbience',
	DynamicPath: 'DynamicPath',
	Test: 'None'
};
export const regionToFeatureValueMap = {
	aus: 'Australia',
	aut: 'Austria',
	bel: 'Belgium',
	can: 'Canada',
	den: 'Denmark',
	fra: 'France',
	ger: 'Germany',
	int: 'International',
	ita: 'Italy',
	lux: 'Luxembourg',
	ned: 'Netherlands',
	swe: 'Sweden',
	che: 'Switzerland',
	tur: 'Turkey',
	gbr: 'United Kingdom',
	usa: 'USA'
};
